// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__FDsyV","logoIcon":"Header_logoIcon__ZnO8P","header":"Header_header__VSrvt","headerButton":"Header_headerButton__-Suhf"};